export const enableDocumentScrollSDKFactory = api => ({
    setIsDocumentScrollEnabled: value => api.setProps({ isDocumentScrollEnabled: value }),
});
//# sourceMappingURL=enableDocumentScrollSDKFactory.js.map